import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { Card, Empty, Table, Tag } from 'antd'
import PageTitle from 'components/PageTitle'
import PaginationContainer from '../../components/Forms/Pagination'
import { formatUrl, getRequest, growthReviewsUrl } from '../../config'

// Past weekly look-backs (spec: 0042_growth_bot Req 3.1).
const ReviewsPage = ({ history }) => {
  const [rows, setRows] = useState([])
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(false)

  const load = async (pageUrl = null) => {
    const response = await getRequest(pageUrl ? formatUrl(pageUrl) : growthReviewsUrl, 'reviews', setLoading)
    if (response.success) {
      setRows(response.data.results || [])
      setMeta({ ...response.data })
    }
  }

  useEffect(() => {
    load()
  }, [])

  /* eslint-disable react/display-name */
  const columns = [
    {
      title: 'Week',
      key: 'week',
      render: (_, r) => {
        const start = moment(r.weekStart)
        return `${start.format('D MMM')} – ${start.clone().add(6, 'days').format('D MMM YYYY')}`
      }
    },
    {
      title: 'Written',
      key: 'ok',
      render: (_, r) => (r.ok ? <Tag color="green">Written</Tag> : <Tag color="red">Failed</Tag>)
    },
    { title: 'Chats', key: 'chats', render: (_, r) => r.headline?.chats ?? '—' },
    { title: 'Paid', key: 'paid', render: (_, r) => r.headline?.paid ?? '—' },
    { title: 'Conversion', key: 'conv', render: (_, r) => (r.headline ? `${r.headline.conversion}%` : '—') }
  ]
  /* eslint-enable react/display-name */

  return (
    <div className="container-fluid">
      <PageTitle title="Growth · Weekly reviews" />
      <Card title="Weekly reviews">
        <Table
          rowKey="id"
          loading={loading}
          dataSource={rows}
          columns={columns}
          pagination={false}
          scroll={{ x: 600 }}
          onRow={r => ({ onClick: () => history.push(`/growth/reviews/${r.id}`), style: { cursor: 'pointer' } })}
          locale={{ emptyText: <Empty description="No reviews yet. The first comes on a Monday." /> }}
        />
        {rows.length ? <PaginationContainer meta={meta} getData={load} /> : null}
      </Card>
    </div>
  )
}

ReviewsPage.propTypes = { history: PropTypes.object }

export default withRouter(ReviewsPage)
